import { Component } from '@angular/core';

@Component({
    selector: 'atx-chat-detail',
    template: `<div class="chat-box">
		                <span class="img-hold">
		                    <img src="../img/leroy.png" alt="logo business">
		                </span>
    <div>
        <p class="title">Leroy Merlín S.A.</p>
        <a class="job">Asesor/a especialista en Decoración de interiores</a>
        <p class="reference">
            Ref. 2645677
            <a class="mute">Silenciar</a>
        </p>
    </div>
</div>

<div class="chat-detail">
    <p class="date">
        <span>10-06-2018</span>
    </p>
    <div class="chat-message p-3">
        <span class="message">Hola John! Soc Marina, responsable de RRHH de Leroy Merin. Estem interessats en el teu perfil. Quan podriam trucar-te?</span>
        <span>9:49:57 AM</span>
    </div>
    <div class="chat-message sent p-3">
        <span class="message">Hola John! Soc Marina, responsable de RRHH de Leroy Merin. Estem interessats en el teu perfil. Quan podriam trucar-te?</span>
        <span>9:49:57 AM</span>
    </div>
</div>
<div class="chat-footer">
    <form action="">
        <button class="back"></button>
        <input id="" class="form-control " type="text" placeholder="Escriu aquí el teu missatge">
        <button class="send"></button>
    </form>
</div>
`,
    styles: [``],
})

export class AtxChatDetailComponent {}
